import { Platform } from "react-native";

const KEY = "awaiting_guest_conversion_ack";

export const setAwaitingAck = () => {
  if (Platform.OS === "web") sessionStorage.setItem(KEY, "true");
};
export const clearAwaitingAck = () => {
  if (Platform.OS === "web") sessionStorage.removeItem(KEY);
};
export const isAwaitingAck = () => Platform.OS === "web" && sessionStorage.getItem(KEY) === "true";
